import axiosHandler from "@/utils/axios-handler";
import axios from "axios";
import { getLocalStorageData } from "@/helpers/local-storage";

const DEFAULT_CONFIG = {
  engine_key: process.env.NEXT_PUBLIC_ENGINE_KEY,
  spelling: "always",
  per_page: 9,
};

let userData = [];
const getUserCoursesAndLessons = async () => {
  let userData = getLocalStorageData("user");
  if (!userData) {
    return;
  }
  const courseOptions = {
    method: "GET",
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses`,
    withCredentials: true,
  };

  const coursesData = await axiosHandler(courseOptions);
  const courses = coursesData?.data?.courses;

  const lessonPromises = courses?.map((course) => {
    const lessonsOptions = {
      method: "GET",
      url: `${process.env.NEXT_PUBLIC_BASE_URL}/v1/users/courses/${course.entryUid}/lessons`,
      withCredentials: true,
    };

    return axiosHandler(lessonsOptions);
  });

  if (lessonPromises) {
    const lessonsData = await Promise.all(lessonPromises);
    const lessons = lessonsData.flatMap((data) => data?.data?.lessons);

    if (courses && lessons) {
      // setUserData([...courses, ...lessons]);
      userData = [...courses, ...lessons];
    }
  }
};

getUserCoursesAndLessons();
export const search = async (q, filters, page) => {
  let availableFilters = [];
  let arrFilter = filters.length > 1 ? filters.split(",") : [filters];

  if (filters.length) {
    arrFilter.map((el) => {
      // Now el contains the uid, so we use it directly for filtering
      availableFilters.push(el);
    });
  }

  // if (filters.length) {
  //   arrFilter.forEach((el) => {
  //     const tags = tagsMapper[el];
  //     tags.forEach(tag => {
  //       availableFilters.push(`${tag}`);
  //     });
  //   });
  // }

  try {
    const body = {
      ...DEFAULT_CONFIG,
      q: `${q.replace(/&/g, " ")}`,
    };

    // Filters
    if (availableFilters.length) {
      body["filters"] = {
        page: {
          tags: availableFilters,
        },
      };
    }

    // Pagination
    if (page) {
      body["page"] = page;
    }

    // body["domain_identifier"] = 1;

    // Search Request
    let result = await axios({
      method: "POST",
      url: "https://search-api.swiftype.com/api/v1/public/engines/search.json",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    });

    if (result.data.info.page.spelling_suggestion) {
      return search(
        result.data.info.page.spelling_suggestion.text,
        filters,
        page
      );
    } else {
      // userData.forEach(userItem => {
      //   result.data.records.page.forEach(resultItem => {
      //     if(userItem.entryUid === resultItem?.entry_uid) {
      //       resultItem["user_data"] = userItem;
      //     }
      //   });
      // });
      let userMap = new Map(
        userData.map((userItem) => [userItem.entryUid, userItem])
      );

      result.data.records.page.forEach((resultItem, i) => {
        if (userMap.has(resultItem.entry_uid)) {
          resultItem["user_data"] = userMap.get(resultItem.entry_uid);
        }
      });

      return result.data;
    }
  } catch (error) {
    console.log("Error: ", error);
  }
};
